import { render, staticRenderFns } from "./gc-footer-value.vue?vue&type=template&id=c6bb368c"
import script from "./gc-footer-value.vue?vue&type=script&lang=js"
export * from "./gc-footer-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports